import React, { Component } from "react";

import "./Content.scss";

class Content extends Component {
  render() {
    const { children } = this.props;
    return <div className="content">{children}</div>;
  }
}

export default Content;
